exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".exampler-wrapper .response__list {\n  padding-top: 0;\n}\n", ""]);

// exports
